<template>
  <div class="bg-white form-sample new-activity">
    <b-overlay :show="toggleOverlay || showOverlay || is_mounting || updating" rounded="sm">
      <b-modal id="order-template-export" @ok="bulkStatement" header-class="p-0"
    footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap">
    <template #modal-title>
        <div class="title-block text-center p-2">{{ $translate('export_statement') }}</div>
        <div class="close-btn" @click="cancel()">x</div>
    </template>
    <form class="my-3 py-3" @submit.stop.prevent="bulkStatement">

      <b-row>
          <b-col cols="12" class="mb-3">
              <label><strong>{{ $translate('select_option') }}</strong></label>
          </b-col>
          <b-col cols="auto" class="mb-3">
              <b-form-radio
                  id="export-option-pdf"
                  v-model="export_option"
                  name="export_option"
                  value="pdf"
                  class="mx-1"
              >&nbsp;{{$translate('PDF')}}</b-form-radio>
          </b-col>
          <b-col cols="auto" class="mb-3">
              <b-form-radio
                  id="export-option-word"
                  v-model="export_option"
                  name="export_option"
                  value="word"
                  class="mr-2"
              >&nbsp;{{$translate('Word')}}</b-form-radio>
          </b-col>
          <b-col cols="auto" class="mb-3">
            <b-form-radio
                id="export-option-excel"
                v-model="export_option"
                name="export_option"
                value="excel"
                class="mr-2"
            >&nbsp;{{$translate('Excel')}}</b-form-radio>
        </b-col>
      </b-row>
  
  </form>
  
    <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" id="export-order-btn" variant="info" @click="ok()">{{ $translate('export') }}</b-button>
        <b-button size="sm" id="close-model-btn" variant="info" @click="cancel()">{{ $cancelLabel() }}</b-button>

    </template>
</b-modal>
      <b-card-body v-if="isNew">
        <div class="d-flex title-bar-block">
          <div class="icon-block me-4">
            <button id="cancel-new-activity-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
              <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="text">
            <span class="me-2">{{ $translate("new_activity") }} </span>
          </div>
        </div>
        <div>
          <portal-target name="OrderSummaryView"> </portal-target>
        </div>
      </b-card-body>

      <b-col cols="12" class="bg-white mt-3 p-3 view-list form-sample" v-else>
        <b-row class="d-flex justify-content-between inner-view title-bar-block">
          <b-col sm="6" md="6" lg="10" class="title-box">
            <div class="d-flex align-items-middle">
              <div class="icon-block me-4">
                <button id="cancel-order-view-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                  <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
              </div>

              {{ orderTypeName(order.order_type_id) }}
              <small class="align-items-center d-flex">
                <template v-if="order.completed_at">
                  &nbsp;-&nbsp;{{ order.completed_at | filterLocalDateTime }}
                </template>
                <span> 
                  &nbsp;-&nbsp;{{order.reference_no}}  
                  <template v-if="order && order.customer && order.customer.name">
                    - {{ order.customer.name }}
                  </template>
                </span>
                  
                &nbsp;&nbsp;
                <b-badge :variant="order | filterStatusVariant">
                  {{ filterStatusName(order) }}</b-badge>
              </small>
            </div>
          </b-col>
          <b-col sm="6" md="6" lg="2" class="text-right">
            <page-actions :buttons-actions="viewButtons" :dropdown-actions="otherActions" control-size="sm"
              :dropdown-disabled="isNew" :align="'justify-content-end'" />
          </b-col>
        </b-row>
        <div class="accordion mt-3">
          <b-card no-body class="accordion-box">
            <div>
              <a id="summery-accordion-toggle" class="accordion-header" :class="{
                  'active-accordion': activeAccordion === 'summary',
                }" @click="activateAccordion('summary')">{{ $translate("summary") }}&nbsp;&nbsp;
                <span  class="accordion-header">
                  <i v-b-tooltip.hover :title="$translate('message')" v-if="orderNotes && orderNotes.length > 0" @click.stop="activateAccordion('messages', order)" class="fa fa-comment"></i>&nbsp;
                  <i v-b-tooltip.hover :title="$translate('attachment')" v-if="attachments && attachments.length > 0" @click.stop="activateAccordion('attachments', order)" class="fa fa-paperclip"></i>&nbsp;
                  <i v-b-tooltip.hover :title="$translate('details')" v-if="(storedAssets && storedAssets.length > 0) || (storedItems && storedItems.length > 0)" @click.stop="activateAccordion('details', order)" class="fa fa-list"></i>
                </span>
              </a>
           
   
            </div>
            <b-collapse :visible="activeAccordion === 'summary'" class="accordion-content">
              <portal-target name="OrderSummaryView"> </portal-target>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box">
            <div>
              <a id="location-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'location',
    }" @click="activateAccordion('location')">{{ $translate("location") }}</a>
            </div>
            <b-collapse :visible="activeAccordion === 'location'" class="accordion-content">
              <portal-target name="deliveryLocationView"></portal-target>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box" v-if="hasLinks">
            <div>
              <a id="links-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'links',
    }" @click="activateAccordion('links')">{{ $translate("associated_activities") }}</a>
            </div>
            <b-collapse :visible="activeAccordion === 'links'" class="accordion-content">
              <activity-links v-if="activeAccordion === 'links'" @change-activity="changeOrder"
                :order="order"></activity-links>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box inner-accordian">
            <div>
              <a id="details-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'details',
    }" @click="activateAccordion('details', order)">{{ $translate("details") }}</a>
            </div>
            <b-collapse :visible="activeAccordion === 'details'" class="accordion-content">
              <portal-target name="OrderItemsView"> </portal-target>
            </b-collapse>
          </b-card>

          <!-- <b-card no-body class="accordion-box">
            <div>
              <a class="accordion-header" :class="{
                'active-accordion': activeAccordion === 'viewRentals',
              }" @click="activateAccordion('viewRentals', order)">{{ $translate("rental") }}</a>
            </div>
            <b-Collapse v-if="activeAccordion === 'viewRentals'" :visible="activeAccordion === 'viewRentals'"
              class="accordion-content">
              <view-rentals  :view-mode="viewMode" :order="order" @input="(rentalData) => rentalData" />
            </b-Collapse>
          </b-card> -->
          <b-card no-body class="accordion-box">
            <div>
              <a id="message-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'messages',
    }" @click="activateAccordion('messages', order)">{{ $translate("messages") }}</a>
            </div>
            <b-collapse :visible="activeAccordion === 'messages'" class="accordion-content">
              <portal-target name="OrderMessagesView"> </portal-target>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box">
            <div>
              <a id="attachment-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'attachments',
    }" @click="activateAccordion('attachments', order)">{{ $translate("attachments") }}</a>
            </div>
            <b-collapse :visible="activeAccordion === 'attachments'" class="accordion-content">
              <portal-target name="OrderAttachmentsView"> </portal-target>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box">
            <div>
              <a id="review-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'reviews',
    }" @click="activateAccordion('reviews', order)">{{ $translate("reviews") }}</a>
            </div>

            <b-collapse :visible="activeAccordion === 'reviews'" class="accordion-content">
              <view-checkoffs :view-mode="viewMode" :is-new="isNew"></view-checkoffs>
            </b-collapse>
          </b-card>

          <b-card no-body class="accordion-box">
            <div>
              <a id="reviewby-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'receivedBy',
    }" @click="activateAccordion('receivedBy', order)">{{ $translate("received_by") }}</a>
            </div>
            <b-Collapse v-if="activeAccordion === 'receivedBy'" :visible="activeAccordion === 'receivedBy'"
              class="accordion-content">
              <view-received-by :view-mode="viewMode" :order="receivedBy" @input="(signatureData) => signatureData" />
            </b-Collapse>
          </b-card>
          <b-card no-body class="accordion-box" v-if="!!order.feedback">
            <div>
              <a id="feedback-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'feedback',
    }" @click="activateAccordion('feedback')">{{ $translate("feedback") }}</a>
            </div>
            <b-Collapse :visible="activeAccordion === 'feedback'" class="accordion-content">
              <b-col class="mt-3">
                <label for="group-feedback" class="mb-3">
                  <strong>{{ $translate("feedback") }}</strong>
                </label>
                <b-form-rating body-class="p-0 text-left" id="input-feedback" v-model="order.feedback" disabled>
                </b-form-rating>
              </b-col>
              <b-col class="mt-3">
                <label for="input-feedback-comments" class="mb-3"><strong>{{ $translate("feedback_comments")
                    }}</strong></label>
                <b-form-textarea id="input-description" rows="3" max-rows="4" v-model="order.feedback_comments"
                  disabled></b-form-textarea>
              </b-col>
            </b-Collapse>
          </b-card>
          <b-card no-body class="accordion-box">
            <div>
              <a id="audit-log-accordion-toggle" class="accordion-header" :class="{
      'active-accordion': activeAccordion === 'audit_logs',
    }" @click="activateAccordion('audit_logs', order)">{{ $translate("audit_logs") }}</a>
            </div>
            <b-Collapse :visible="activeAccordion === 'audit_logs'" class="accordion-content">
              <b-col>
                <b-table responsive :fields="fields" :items="auditLogs">
                  <template #cell(user)="{ item }">
                    <span>
                      {{ `${item.user.first_name} ${item.user.last_name}` }}
                    </span>
                  </template>

                  <template #cell(message)="{ item }">
                    <span class="lh-base" v-html="item.message"></span>
                  </template>
                </b-table>
              </b-col>
            </b-Collapse>
          </b-card>
        </div>
      </b-col>
    </b-overlay>

    <ReportsDialog ref="reportsDialog" :order-id="order.id" :statement-type="reportStatment.statement_type"
      :title="reportStatment.title" />

    <create-template-from-order />

    <portal to="OrderSummaryView">
      <view-order-summary ref="ord-sum-ref" :view-mode="viewMode" :updating="updating"
        @change-mode="(evt) => (viewMode = evt)" @set-location-section="setLocation" @set-customer-id="setCustomer" />
    </portal>

    <portal to="deliveryLocationView" v-if="activeAccordion === 'location' || isNew">
      <location-section :sectionOnly="true" v-model="delivery_location_section_id" :hide-controls="!isNew"
        @set-location-section="(evt) => { setLocationData(evt, 'deliveryLocation') }" :disabled="!(isNew || !viewMode)"
        :customer_id="customer_id || order?.customer_id">
      </location-section>
    </portal>

    <portal to="OrderItemsView">
      <manage-order-items :view-mode="viewMode" :order_template_id="order_template_id" :is-new="isNew" :order="order"
        @change-mode="viewMode = $event" :customer-assets="customerAssets" @return-item-submitted="evt => returnItemSubmitted(evt)"/>
    </portal>

    <portal to="OrderMessagesView">
      <view-notes :view-mode="viewMode" :is-new="isNew" @addMessage="evt => runSaveActionNew()"/>
    </portal>

    <portal to="OrderAttachmentsView">
      <view-attachments :view-mode="viewMode" :is-new="isNew" />
    </portal>

    <b-modal id="convertOrderType" v-model="isConvertOrderType" header-class="p-0"
      footer-class="d-flex justify-content-center border-0" content-class="custom-model-wrap" @ok="convertOrderType">
      <template #modal-title="{ cancel }">
        <div class="title-block text-center p-2">
          {{ $translate("convert_activity_title") }}
        </div>
        <button @click="cancel()" class="close-btn">x</button>
      </template>
      <template #default>
        <b-col class="dd">
          <label class="mb-3"><strong>{{ $translate("type") }}<span class="red">*</span></strong></label>
          <b-form-select class="form-control" id="input-type" v-model="new_order_type_id"
            :options="orderTypes | mapOptions" required>
            <template #first>
              <b-form-select-option :value="null" disabled>{{
      $translate("select_new_activity_type")
    }}</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
      </template>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="info" class="btn-fw" @click="ok()">{{
      $translate("ok")
    }}</b-button>
        <b-button variant="info" class="btn-fw" @click="cancel()">{{
      $cancelLabel()
    }}</b-button>
      </template>
    </b-modal>

    <div class="ps-3 mt-4 d-flex justify-content-center gap-2">
      <b-button v-if="hasPermissionCreate && isNew" @click="createNewOrder" class="me-2 btn-fw" variant="info"
        :disabled="updating || toggleOverlay || showOverlay || is_mounting">{{
      updating
        ? this.$translate("creating_new_activity")
        : this.$translate("create_new_activity")
    }}</b-button>
      <b-button v-if="showLocationBtn" @click="setLocationSearchMode" variant="info" class="me-2"
        :disabled="viewMode || updating">{{ this.$translate("locations") }}</b-button>

      <b-button v-if="showUpdateBtn && hasPermissionUpdate" variant="info" @click="runSaveActionNew" class="btn-fw"
        :disabled="updating || viewMode || toggleOverlay || showOverlay || is_mounting
      ">{{
      updating
        ? this.$translate("saving_changes")
        : this.$translate("save_changes")
        }}</b-button>
      <b-button variant="info" @click="cancel()" class="btn-fw">{{
        $cancelLabel()
        }}</b-button>
    </div>
  </div>
</template>
<script>
import EventBus from "@/exports/event-bus.js";
import api from "@/api/order";
import CreateTemplateFromOrder from "@/components/CreateTemplateFromOrder.vue";
import ManageOrderItems from "./ManageOrderItems.vue";
// import ManageOrderAssetRentals from "./ManageOrderAssetRentals.vue";
import ViewNotes from "./ViewNotes.vue";
import ViewAttachments from "./ViewAttachments.vue";
import ViewReceivedBy from "./ViewReceivedBy.vue";
///import moment from 'moment'
import PageActions from "@/components/PageActions.vue";
import ReportsDialog from "@/components/ReportsDialog.vue";

import LocationSection from "@/views/Location/LocationSection";
import ViewOrderSummary from "./ViewOrderSummary";
import ViewCheckoffs from "./ViewCheckoffs.vue";
import ActivityLinks from "./ActivityLinks.vue";
//mixins
import dateTimeMixins from "@/mixins/dateTimeMixins";
import popupMixins from "@/mixins/popupMixins";
import utilityMixins from "@/mixins/utilityMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
//report templates
import { STATEMENT_TYPES } from "@/exports/jsreport_templates";
import moment from "moment";
import locationMixins from "@/mixins/locationMixins"

const tabNames = [
  "summary", // 0,
  "location", // 1,
  "items", // 2,
  "messages", // 3,
  "attachments", // 4,
  "reviews", // 5,
  "receivedBy", // 6,
];
export default {
  name: "orders-view",
  components: {
    CreateTemplateFromOrder,
    ManageOrderItems,
    // ManageOrderAssetRentals,
    ViewNotes,
    LocationSection,
    ViewAttachments,
    ViewReceivedBy,
    ViewOrderSummary,
    ViewCheckoffs,
    PageActions,
    ReportsDialog,
    ActivityLinks,
  },
  mixins: [
    dateTimeMixins,
    popupMixins,
    utilityMixins,
    permissionsMixins,
    locationMixins
    // reportMixins,
  ],
  data() {
    return {
      tabIdx: 0,
      tabNames,
      activeAccordion: "summary",
      viewMode: true,
      delivery_location_section_id: null,
      customer_id: null,
      order_type_id: null,
      new_order_type_id: null,
      order_template_id: null,
      formStatus: {},
      driverModified: false,
      updating: false,
      toggleOverlay: false,
      summaryChanged: false,
      deliveryLocation: {},
      previousModel: null,
      customerAssets: [],
      isConvertOrderType: false,
      is_mounting: false,
      STATEMENT_TYPES,
      reportStatment: {},
      export_option : ""
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    filterStatusVariant(item) {
      return item.completed ? "success" : item.released ? "primary" : "danger";
    },
    mapOptions(arr, isUser) {
      return arr.map((x) => ({
        value: x.id,
        text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
      }));
    },
  },

  computed: {
    fields() {
      return [
        {
          key: "created_at",
          label: this.$translate("date"),
          formatter: (value, key, item) =>
            moment(new Date(item.created_at)).format("YYYY-MM-DD hh:mm:A"),
        },
        { key: "type", label: this.$translate("type") },
        { key: "user", label: this.$translate("user") },
        { key: "message", label: this.$translate("messages") },
      ];
    },
    hasLinks() {
      return (
        (this.order.secondary_orders || []).length +
        (this.order.primary_orders || []).length >
        0
      );
    },
    componentName() {
      return this.$translate("activity");
    },
    allowToUpdateOtherOfficers() {
      return !!this.user_permissions.includes(
        "update.activity.assigned.to.others"
      );
    },
    allowToDeleteOtherOfficers() {
      return !!this.user_permissions.includes(
        "delete.activity.assigned.to.others"
      );
    },
    viewButtons() {
      const actions = [];
      if (!this.isNew) {
        actions.push({
          action: () => this.toggleView(),
          icon: this.viewMode ? "pencil" : "eye",
          faIcon: this.viewMode ? "fa fa-pencil-square" : "fa fa-eye",
          variant: "light",
          tooltip: this.viewMode
            ? this.$translate("switch_to_edit_state")
            : this.$translate("switch_to_view_state"),
        });
      }
      actions.push({
        action: () => this.launchNewOrder(),
        icon: "plus-circle",
        faIcon: "fa fa-plus-circle me-2",
        variant: "light",
        size: "sm",
        tooltip: this.$translate("create_new_activity"),
      });
      return actions;
    },
    otherActions() {
      const actions = [];

      actions.push({
        action: () => this.cancelOrder(),
        text: this.$translate("cancel_activity"),
      });
      actions.push({
        action: () => this.toggleCompletion(),
        text: this.order.completed
          ? this.$translate("mark_as_incomplete")
          : this.$translate("mark_as_complete"),
        // disabled: this.viewMode,
      });
      actions.push({
        action: () => this.releaseActivity(),
        text: this.$translate("release_activity"),
        disabled: this.viewMode,
      });
      if (this.hasPermissionCreate) {
        actions.push({
          action: () => this.openConvertOTModal(),
          text: this.$translate("convert_activity"),
          // disabled: this.viewMode,
        });
      }
      if (
        this.hasPermissionUpdate &&
        ((this.orderItems.length > 0 &&
        this.orderItems.some((x) => x.id)) || (this.orderAssetRentalItems.length > 0 &&
        this.orderAssetRentalItems.some((x) => x.id)))
      ) {
        actions.push({
          action: () => this.showOrderTemplateModal(),
          text: this.$translate("create_template"),
          disabled: this.viewMode,
        });

        actions.push({
          action: () => this.processReport(0, "Download Invoice"),
          text: this.$translate("download_invoice"),
          // disabled: this.viewMode,
        });
        if (this.isCustomStatement) {
          actions.push({
            action: () => this.processReport(1, "Download Statement"),
            text: this.$translate("download_statement"),
            // disabled: this.viewMode,
          });
        } else {
          actions.push({
            action: () => this.processReport(2, "Download Statement"),
            text: this.$translate("download_statement"),
            // disabled: this.viewMode,
          });
        }
      }
      if (this.hasPermissionDelete) {
        actions.push({
          action: () => this.deleteOrder(),
          text: this.$translate("delete_activity"),
          disabled:
            !this.allowToDeleteOtherOfficers &&
            this.order.driver_id != this.$store.state.user.id,
        });
      }
      if (
        this.hasPermissionCreate &&
        !this.order.completed &&
        !this.order.released
      ) {
        actions.push({
          action: () => this.duplicateActivity(),
          text: this.$translate("duplicate_activity"),
          disabled: this.viewMode,
        });
      }

      actions.push({
        action: () => this.openModal(),
        text: this.$translate("activity_statement"),
        // disabled: this.viewMode,
      });
      if (
        this.hasPermissionCreate &&
        this.order.completed
      ) {
        actions.push({
          action: () => this.create_receipt(),
          text: this.$translate("generate_reciept"),
         
        });
      }
      return actions;
    },

    isCustomStatement() {
      return !!(this.taskTypeValue && this.taskTypeValue.isTaskType);
    },

    entities() {
      const _entities = this.$store.getters["transactionType/entities"];
      console.log("----entities", _entities);
      return _entities;
    },
    entity() {
      ///// this.orderTypes.find(x => x.id === this.order.order_type_id) ||
      const { orderTypes, order_type_id, orderType } = this;
      console.log("order type----", {
        orderTypes,
        orderType,
        order_type_id,
      });
      return (
        orderType &&
        orderType.transaction_type &&
        orderType.transaction_type.entity
      );
    },
    orderTypes() {
      return this.$store.getters["orderType/activityTypesByPermission"];
    },
    showOverlay() {
      return this.$store.state.orders.orderLoadingState;
    },

    order() {
      return this.$store.state.orders.item;
    },

    orderItems() {
      return this.$store.state.orders.orderItems;
    },

    orderAssetRentalItems() {
      return this.$store.state.orders.orderAssetRentalItems;
    },

    orderId() {
      return this.$route.params.id;
    },

    isNew() {
      return !(this.$route.params.id > 0);
    },

    orderType() {
      const { orderTypes, order_type_id } = this;

      console.log("orderTypes", orderTypes);

      if (orderTypes && orderTypes.length > 0 && order_type_id) {
        return orderTypes.find((x) => x.id === order_type_id);
      }

      return null; // or return a default object or value, if desired
    },

    storedItems() {
      return this.$store.state.orderItemStore.items;
    },
    storedAssets() {
      return this.$store.state.orderRentalAssetStore.items;
    },
    arrangedItems() {
      return this.$store.state.orderItemStore.arranged_items;
    },
    orderChanged() {
      return this.$store.state.orderItemStore.orderChanged;
    },
    arrangedAssetRentalItems() {
      return this.$store.state.orderRentalAssetStore.arranged_items;
    },
    orderAssetRentalChanged() {
      return this.$store.state.orderRentalAssetStore.orderChanged;
    },

    storedMessages() {
      return this.$store.state.orderMessagesStore.messages;
    },

    storedAttachments() {
      return this.$store.state.orderAttachmentsStore.attachments;
    },

    attachmentsChanged() {
      return this.$store.state.orderAttachmentsStore.itemsChanged;
    },

    itemsChanged() {
      return this.$store.state.orderItemStore.itemsChanged;
    },

    itemDeleted() {
      return this.$store.state.orderItemStore.itemDeleted;
    },

    rentalAssetItemsChanged() {
      return this.$store.state.orderRentalAssetStore.itemsChanged;
    },

    rentalAssetItemsDeleted() {
      return this.$store.state.orderRentalAssetStore.itemDeleted;
    },

    messagesChanged() {
      return this.$store.state.orderMessagesStore.itemsChanged;
    },

    showUpdateBtn() {
      return this.hasPermissionUpdate && !this.isNew && this.tabIdx <= 4;
    },

    showLocationBtn() {
      const { hasPermissionUpdate } = this;
      return hasPermissionUpdate && this.activeAccordion == "location";
    },
    taskTypeValue() {
      const taskTypeValue = this.$store.getters["company/taskTypeValue"];
      console.log("computed taskTypeValue", taskTypeValue);
      return taskTypeValue;
    },

    taskTypeKey() {
      return this.$store.state.company.settingKeys.taskTypeKey;
    },

    attachments() {
      return this.$store.state.orders.attachments || [];
    },

    orderNotes() {
      return this.$store.state.orders.notes;
    },

    auditLogs() {
      return this.$store.state.orders.auditLogs || [];
    },

    receivedBy() {
      return this.$store.state.orders.receivedBy || {};
    },
    
  },

  watch: {
    order: {
      handler: function () {
        this.previousModel = null;
      },
      deep: true,
    },
    $route() {
      const id = parseInt(this.$route.params.id);
      console.log("$route watch id", id);
      this.fetchOrderAssets(id);
    },

    tabIdx: function (idx) {
      console.log("tabIdx", idx);
      if (idx === 2) {
        console.log("");
      }
    },
  },
  async created() {
    this.$store.commit("orderAttachmentsStore/SET_ATTACHMENTS", []);
    this.$store.commit("orderMessagesStore/SET_MESSAGES", []);
    this.$store.commit("orders/SET_NOTES", []);
    this.$store.commit("orders/SET_ORDER_ITEMS", []);
    this.$store.commit("orders/SET_ORDER_ASSET_RENTAL_ITEMS", []);
    this.$store.commit("locations/SET_LOCATION", {});
    EventBus.$on("set-order-model", ({ order, driverModified }) => {
      console.log("orderModel--viewOrder", order);
      console.log("modified officer", driverModified);
      this.driverModified = driverModified;
      this.order_type_id = order && order.order_type_id;
      this.order_template_id = order && order.order_template_id;
      this.$nextTick(() => {
        // this.setDeliveryLocation(order)
        // this.getCustomerAllAssets(order.customer_id)
      });
    });

    EventBus.$on("update-order-template", (evt) => {
      console.log("update-order-template", evt);
      this.order_template_id = evt;
    });

    try {
      this.is_mounting = true;
      await this.$store.dispatch("additionalField/fetchAll", {
        module_for: 1,
      });

      await this.$store.dispatch("orderType/fetchAll");
      const id = parseInt(this.$route.params.id);
      await this.$store.dispatch("orders/fetchById", id);

      setTimeout(() => {
        Promise.all([
          this.$store.dispatch("interactionType/fetchAll"),
          this.$store.dispatch("progressStatus/fetchAll"),
          this.$store.dispatch("orderTemplate/fetchAll"),
          this.$store.dispatch("requestCategory/fetchAll"),
          this.$store.dispatch("checkoffTypes/fetchAll"),
          this.$store.dispatch("users/fetchAll"),
          this.$store.dispatch("customerAgents/fetchAll"),
          this.$store.dispatch('crmOpportunityTypes/fetchAll'),
          this.$store.dispatch('health/fetch', { query: "", page: 0 })
        ]);

        if (id > 0) {
          Promise.all([
            this.loadCustomerAssets(this.order.customer_id),
            this.$store.dispatch("itemType/fetchAll"),
            this.fetchOrderAssets(id),
          ]);
        }
      }, 500);
      // await this.fetchOrderAssets(id)
    } catch (err) {
      console.log("viewOrder created err", err);
    } finally {
      this.is_mounting = false;
    }
  },

  async mounted() {
    this.is_mounting = true;
    // this.$store.dispatch('company/fetchConfiguration', this.taskTypeKey)
    const id = parseInt(this.$route.params.id);
    if(id > 0){
      await this.$store.dispatch("orders/fetchAttachments", this.orderId);
      await this.$store.dispatch("orders/fetchNotes", this.orderId);
    }
    this.is_mounting = false;
  },
  methods: {
    orderTypeName(id) {
      const orderType = this.orderTypes.find((x) => x.id === id);
      return orderType && orderType.name;
    },
    filterStatusName(item) {
      return item.completed
        ? this.$translate("completed")
        : item.released
          ? this.$translate("processing")
          : this.$translate("pending");
    },
    async activateAccordion(section, order = null) {
      console.log('this is called , open!',section);
      if (this.activeAccordion === section) {
        this.activeAccordion = null;
      } else {
        this.activeAccordion = section;
      }
      try {
        this.is_mounting = true;
        if (this.activeAccordion != null && section == "details") {
          const id = parseInt(this.$route.params.id);
          await Promise.all([
            this.loadCustomerAssets(order.customer_id),
            this.$store.dispatch("itemType/fetchAll"),
            this.fetchOrderAssets(id),
          ]);
          // EventBus.$emit(
          //   "set-customer-assets",
          //   this.customerAssets
          // );
        }

        if (this.activeAccordion != null && section == "location") {
          await Promise.all([
            this.$store.dispatch("locations/fetchWarehouses"),
            this.setDeliveryLocation(order),
          ]);
        }
        if (
          this.activeAccordion != null &&
          (section == "attachments" || section == "reviews")
        ) {
          // await this.$store.dispatch('js_report/fetchCredentials')
          if (section == "attachments") {
            await this.$store.dispatch("orders/fetchAttachments", order.id);
          }
          if (section == "reviews") {
            await this.$store.dispatch("orders/fetchCheckoffs", order.id);
          }
        }

        if (this.activeAccordion != null && section == "messages") {
          await this.$store.dispatch("orders/fetchNotes", order.id);
        }

        if (this.activeAccordion != null && section == "audit_logs") {
          await this.$store.dispatch("orders/fetchAuditLogs", order.id);
        }

        if (this.activeAccordion != null && section == "receivedBy") {
          await this.$store.dispatch("orders/fetchReceivedBy", order.id);
        }
      } catch (err) {
        console.error("viewOrder activateAccordion err", err);
      } finally {
        this.is_mounting = false;
      }
    },
    setLocation(val) {
      console.log("delivery_location_section_id", val);
      this.delivery_location_section_id = val;
    },
    setCustomer(val) {
      console.log("setCustomer:", val);
      this.customer_id = val;
    },
    processReport(type, title) {
      let statement_type = this.STATEMENT_TYPES[type];
      //if (type == 0) {
      //  statement_type = "custom_invoice";
      //}
      this.reportStatment = { statement_type, title };
      this.$refs.reportsDialog.show();
    },

    cancel() {
      this.delivery_location_section_id = null;
      this.$store.commit("orders/SET_ORDER", {});
      this.$store.commit("orders/SET_ORDER_ITEMS", []);
      this.$store.commit("orders/SET_ORDER_ASSET_RENTAL_ITEMS", []);
      this.$store.commit("orders/SET_CHECKOFFS", []);
      this.$store.commit("orders/SET_NOTES", []);
      this.$store.commit("orders/SET_ATTACHMENTS", []);
      this.$store.commit("orderAttachmentsStore/SET_ATTACHMENTS", []);
      this.$router.push("/ams/activities");
     
    },

    changeOrder(id) {
      this.activeAccordion = "summary";
      this.$router.push(`/ams/activities/${id}`);
    },

    setLocationSearchMode() {
      EventBus.$emit("set-location-search-mode");
    },
    setDeliveryLocation(orderModel) {
      let { isNew, previousModel, order } = this;
      if (
        isNew &&
        (!previousModel || previousModel.customer_id !== orderModel.customer_id)
      ) {
        this.delivery_location_section_id =
          (orderModel &&
            orderModel.customer &&
            orderModel.customer.location_section_id) ||
          null;
      } else if (!isNew && !previousModel) {
        this.delivery_location_section_id =
          order && order.delivery_location_section_id;
      }
      this.previousModel = { ...orderModel };
    },
    cancelOrder() {
      this.$router.push("/ams/activities");
    },
    toggleView() {
      if (this.order && this.order.completed === 1) {
        this.doToast(
          this.$translate("error"),
          this.$translate("activity_completed"),
          "danger"
        );
      } else if (
        this.allowToUpdateOtherOfficers ||
        this.order.driver_id == this.$store.state.user.id
      ) {
        this.viewMode = !this.viewMode;
      } else {
        this.doToast(
          this.$translate("error"),
          `${this.$translate("error_not_authorized")} ${this.$translate(
            "update"
          )} ${this.$translate("asigned_to_another_user")}`,
          "danger"
        );
      }
    },
    launchNewOrder() {
      this.delivery_location_section_id = null;
      this.$store.commit("orders/SET_ORDER", {});
      this.$store.commit("orders/SET_ORDER_ITEMS", []);
      this.$store.commit("orders/SET_ORDER_ASSET_RENTAL_ITEMS", []);
      this.$store.commit("orders/SET_CHECKOFFS", []);
      this.$store.commit("orders/SET_NOTES", []);
      this.$store.commit("orderAttachmentsStore/SET_ATTACHMENTS", []);
      this.$store.commit("orderMessagesStore/SET_MESSAGES", []);
      this.$store.commit("orders/SET_ATTACHMENTS", []);
      this.$router.push("/ams/activities/0");
    },
    showOrderTemplateModal() {
      this.$refs["ord-sum-ref"].showOrderTemplateModal();
    },
    async downloadPdf(statement_type) {
      try {
        this.toggleOverlay = true;
        const { orderId: order_id } = this;
        const fileName = "statement.pdf";
        await this.$store.dispatch("js_report/downloadStatement", {
          order_id,
          statement_type,
          fileName,
        });
      } catch (error) {
        console.error("downloadPdf:", error);
        this.doToast(
          this.$translate("error"),
          this.$translate("error_download"),
          "danger"
        );
      } finally {
        this.toggleOverlay = false;
      }
    },

    async fetchOrderAssets(id) {
      if (id) {
        // await this.$store.dispatch("orders/fetchById", id);
        this.$store.dispatch("orders/fetchOrderItems", id);
        this.$store.dispatch("orders/fetchOrderAssetRentalItems", id);
      } else {
        this.$store.commit("orders/SET_ORDER", {});
        this.$store.commit("orders/SET_ORDER_ITEMS", []);
      }
    },

    doPause() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          return resolve();
        });
      });
    },

    async buildDuplicateOrder(order_type_id) {
      const {
        id,
        customer_id,
        driver_id,
        order_type_id: p_order_type_id,
        description,
        delivery_location_section_id,
        request_category_id,
        signature,
      } = this.order;

      let items = this.storedItems;

      if (!items || !items.length) {
        await this.fetchOrderAssets(id);
      }

      await this.doPause();

      items = this.storedItems;

      console.log("buildDuplicateOrder order:", this.order);
      console.log("buildDuplicateOrder items:", items);

      if (!customer_id)
        throw new Error(this.$translate("customer_not_assined"));
      // if (!items || !items.length)
      //   throw new Error(this.$translate("items_not_assined")); # this will allow to convert activity even if the item is not there

      order_type_id = order_type_id || p_order_type_id;

      const model = {
        customer_id,
        driver_id,
        description,
        order_type_id,
        delivery_location_section_id,
        request_category_id,
        signature,
      };

      model.duplicate_order_id = id;
      const d = new Date(Date.now() + 60 * 60 * 24 * 1000);
      model.schedule_at = this.getLaravelDateTime(d);
      return model;
    },

    async openConvertOTModal() {
      this.isConvertOrderType = true;
    },

    async convertOrderType() {
      try {
        this.toggleOverlay = true;

        const { new_order_type_id } = this;

        const model = await this.buildDuplicateOrder(new_order_type_id);

        console.log("convertOrderType:  model", model);

        const data = await this.$store.dispatch("orders/create", model);

        console.log("created data", data);
        await this.$store.dispatch("orders/fetchById", data.id);
        await this.$store.dispatch('acitivityTypeDocStore/fetchdocumentsAll', {  activityTypeId : new_order_type_id,order_id :data.id});
        this.doToast(
          this.$translate("success"),
          `${this.$translate("activity")} ${data.reference_no
          } ${this.$translate("create_alert")}`,
          "success"
        );

        this.isConvertOrderType = false;
        this.$router.push(`/ams/activities/${data.id}`);
      } catch (err) {
        console.log(err);
        this.doToast(this.$translate("invalid"), err.message, "danger");
      } finally {
        this.toggleOverlay = false;
      }
    },

    runSaveAction() {
      if (this.activeAccordion == "summary") {
        this.updateOrder();
      }
      if (this.activeAccordion == "location") {
        this.updateOrder();
      }
      if (this.activeAccordion == "details") {
        this.updateOrderItems();
      }
      if (this.activeAccordion == "messages") {
        this.updateNotes();
      }

      if (this.activeAccordion == "attachments") {
        this.updateAttachments();
      }
    },

    runSaveActionNew() {
      if(!(this.$route.params.id > 0)) return;
      if (this.activeAccordion == "messages") {
        this.updateNotes();
      } else {
        this.updateOrderNew();
      }
    },

    async updateAttachments() {
      const saveAttachment = async (payload) => {
        payload.order_id = this.order.id;
        await this.$store.dispatch("orders/addAttachment", payload);
      };

      const deleteAttachment = async (id) => {
        await this.$store.dispatch("orders/deleteAttachment", {
          order_id: this.order.id,
          attachment_id: id,
        });
      };

      try {
        this.updating = true;
        const { storedAttachments: newAttachments } = this;
        const markedDeletedArray = [];
        for (const oldAttachment of this.attachments) {
          if (
            !newAttachments
              .filter((x) => !!x.id)
              .find((x) => x.id == oldAttachment.id)
          ) {
            markedDeletedArray.push(oldAttachment.id);
          }
        }
        //delete messages
        await Promise.all(markedDeletedArray.map(deleteAttachment));
        //create messages
        await Promise.all(
          newAttachments.filter((x) => !x.id).map(saveAttachment)
        );
        await this.$store.dispatch("orders/fetchAttachments", this.order.id);
        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${this.$translate("activity")} ${this.$translate("update_alert")}`
        );
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.updating = false;
      }
    },

    async updateNotes() {
      console.log("checkUpdateNotes");
      const createNote = async (content) => {
        await api.createNote(this.order.id, content);
      };

      const deleteNote = async (id) => {
        await api.deleteNote(this.order.id, id);
      };
      try {
        this.updating = true;
        const { storedMessages: newNotes } = this;
        const markedDeletedArray = [];
        for (const oldNote of this.orderNotes) {
          if (!newNotes.filter((x) => !!x.id).find((x) => x.id == oldNote.id)) {
            markedDeletedArray.push(oldNote.id);
          }
        }
        //delete messages
        await Promise.all(markedDeletedArray.map(deleteNote));
        //create messages
        await Promise.all(
          newNotes.filter((x) => !x.id).map((x) => createNote(x.content))
        );
        await this.$store.dispatch("orders/fetchNotes", this.order.id);
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.updating = false;
      }
    },

    async updateOrderItems() {
      try {
        this.updating = true;
        if (this.orderChanged == true) {
          const { arrangedItems: items } = this;
          await this.$store.dispatch("orders/updateItemOrder", { items });
          this.doToast(
            this.$translate("updated"),
            `${this.$translate("activity")} ${this.$translate("update_alert")}`,
            "success"
          );
        } else {
          const model = this.$refs["ord-sum-ref"].getModel();
          const { id } = model;
          const total = 0;
          const { storedItems: items } = this;
          await this.$store.dispatch("orders/updateOrderItems", {
            id,
            items,
            total,
          });
          this.genericToast(
            this.$translate("details"),
            this.$translate("updated"),
            "success",
            `${this.$translate("details")} ${this.$translate("save_alert")}`
          );
        }
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.updating = false;
      }
    },

    async createNewOrder() {
      
      try {
        this.updating = true;
        const summary = this.$refs["ord-sum-ref"].getModel();


        
        const {
          storedItems: items,
          storedAssets: asset_items,
          storedMessages: _notes,
          storedAttachments: attachments,
          delivery_location_section_id,
          deliveryLocation,
          order_template_id,
        } = this;

        console.log(
          "delivery location section id",
          delivery_location_section_id
        );
        const notes = _notes && _notes.map((x) => x.content);
        console.log("deliveryLocation", deliveryLocation);
        const model = {
          ...summary,
          ...deliveryLocation,
          items,
          asset_items,
          notes,
          attachments,
          delivery_location_section_id,
          order_template_id,
        };
        model.schedule_at = this.getLaravelFrLocalParts(model.date, model.time);
        model.signature = model.signature || false;
        delete model.date;
        delete model.time;

        this.checkLocationError(model, delivery_location_section_id);

        console.log("modelssss", model);

        await this.$refs["ord-sum-ref"].validateOrderSummary();

        const data = await this.$store.dispatch("orders/create", model);
        this.doToast(
          this.$translate("success"),
          `${this.$translate("activity")} ${data.reference_no
          } ${this.$translate("create_alert")}`,
          "success"
        );
        await this.$store.dispatch("orderItemStore/deleteTemplate");
        await this.$store.commit("orders/SET_ORDER", data);
        this.$router.push(`/ams/activities/${data.id}`);
      } catch (err) {
        console.error("createNewOrder", err);
        //"SQLSTATE[23000]: Integrity constraint violation: 1062 Duplicate entry 'Del-110' for key 'orders_reference_no_unique' (SQL: insert into `orders` (`request_category_id`, `customer_id`, `driver_id`, `description`, `delivery_location_section_id`, `created_by`, `schedule_at`, `signature`, `order_type_id`, `reference_no`, `order_template_id`, `linked_assets`, `updated_at`, `created_at`) values (3, 1, 18, testr, 5, 1, 2022-11-11 09:30:00, 0, 1, Del-110, , [], 2022-11-10 20:58:00, 2022-11-10 20:58:00))"
        const duplicateCustomerName = "Duplicate Name";
        const invalidCustomerNameMsg =
          "Cannot read properties of undefined (reading 'name')";
        let message = err.message;

        if (message == duplicateCustomerName) {
          message = this.$translate("customer_name_exists");
        }
        if (message == invalidCustomerNameMsg) {
          message = this.$translate("customer_name_required");
        }

        if (
          message.indexOf("Duplicate entry") >= 0 &&
          message.indexOf("orders_reference_no_unique") >= 0
        ) {
          message = this.$translate("duplicate_reference");
        }

        this.doToast(this.$translate("invalid"), message, "danger");
      } finally {
        this.updating = false;
      }
    },

    async updateOrder() {
      try {
        const {
          delivery_location_section_id,
          deliveryLocation,
          order_template_id,
        } = this;
        const summary = { ...this.$refs["ord-sum-ref"].getModel() };

        const { date, time, signature } = summary;

        delete summary.date;
        delete summary.time;

        const schedule_at = this.getLaravelFrLocalParts(date, time);

        summary.signature = signature ? 1 : 0;

        const updateModel = {
          ...summary,
          ...deliveryLocation,
          delivery_location_section_id,
          schedule_at,
          order_template_id,
        };

        this.checkLocationError(updateModel, delivery_location_section_id);

        console.log("updateModel:", updateModel);
        this.updating = true;

        await this.$store.dispatch("orders/update", updateModel);
        let toastComponentName = this.$translate("activity");

        if (this.driverModified == true) {
          toastComponentName = this.$translate("officer");
        }
        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${toastComponentName} ${this.$translate("update_alert")}`
        );
        this.driverModified = false;
        this.viewMode = true;
        this.$forceUpdate();
      } catch (error) {
        console.error("update", error);
        let message =
          error.message || this.$translate("error_updating_activity");
        this.doToast(this.$translate("error"), message, "danger");
      } finally {
        console.log("done bingo bye");
        this.updating = false;
      }
    },

    async updateOrderNew() {

      console.log('update method is called');
      try {
        const {
          delivery_location_section_id,
          deliveryLocation,
          order_template_id,
        } = this;
        const summary = { ...this.$refs["ord-sum-ref"].getModel() };
        console.log('summary is',summary);
        const { date, time, signature } = summary;

        delete summary.date;
        delete summary.time;

        const schedule_at = this.getLaravelFrLocalParts(date, time);

        summary.signature = signature ? 1 : 0;

        // details tab data
        let updateItemOrder = [];
        let updateOrderItems = {};
        if (this.orderChanged == true) {
          const { arrangedItems: items } = this;
          updateItemOrder = items;
        } else {
          const total = 0;
          const { storedItems: items } = this;
          updateOrderItems = {
            items,
            total,
          };
        }

        // details tab asset rental items data
        let updateAssetRentalItemOrder = [];
        let updateOrderAssetRentalItems = {};
        if (this.orderAssetRentalChanged == true) {
          const { arrangedAssetRentalItems: rentalItems } = this;
          updateAssetRentalItemOrder = rentalItems;
        } else {
          const total = 0;
          const { storedAssets: rentalItems } = this;
          updateOrderAssetRentalItems = {
            items: rentalItems,
            total,
          };
        }

        // Attachments
        let { storedAttachments: newAttachments } = this;
        const markedDeletedAttachmentsArray = [];
        for (const oldAttachment of this.attachments) {
          if (
            !newAttachments
              .filter((x) => !!x.id)
              .find((x) => x.id == oldAttachment.id)
          ) {
            markedDeletedAttachmentsArray.push(oldAttachment.id);
          }
        }
        newAttachments = newAttachments.filter((x) => !x.id);

        // Notes (Messages)
        let { storedMessages: newNotes } = this;
        const markedDeletedNotesArray = [];
        for (const oldNote of this.orderNotes) {
          if (!newNotes.filter((x) => !!x.id).find((x) => x.id == oldNote.id)) {
            markedDeletedNotesArray.push(oldNote.id);
          }
        }
        newNotes = newNotes.filter((x) => !x.id);
        const itemsChanged = this.itemsChanged;
        const itemDeleted = this.itemDeleted;
        const rentalAssetItemsChanged = this.rentalAssetItemsChanged;
        const rentalAssetItemsDeleted = this.rentalAssetItemsDeleted;
        const updateModel = {
          ...summary,
          ...deliveryLocation,
          delivery_location_section_id,
          schedule_at,
          order_template_id,
          updateItemOrder,
          updateOrderItems,
          updateAssetRentalItemOrder,
          updateOrderAssetRentalItems,
          itemsChanged,
          itemDeleted,
          rentalAssetItemsChanged,
          rentalAssetItemsDeleted,
          attachments: newAttachments,
          deleted_attachments: markedDeletedAttachmentsArray,
          notes: newNotes,
          deleted_notes: markedDeletedNotesArray,
        };

        await this.checkLocationError(updateModel, delivery_location_section_id);

        console.log("updateModel:", updateModel);
        this.updating = true;

        await this.$store.dispatch("orders/update", updateModel);
        let toastComponentName = this.$translate("activity");

        if (this.driverModified == true) {
          toastComponentName = this.$translate("officer");
        }

        this.driverModified = false;
        this.viewMode = true;
        this.$store.commit("orderAttachmentsStore/SET_ATTACHMENTS", []);
        this.$store.commit("orderMessagesStore/SET_MESSAGES", []);

        this.$store.commit("orders/SET_ATTACHMENTS", []);
        this.$store.commit("orders/SET_NOTES", []);

        await this.$store.dispatch(
          "orders/fetchById",
          this.$route.params.id
        );

        await this.$store.dispatch(
          "orders/fetchAttachments",
          this.$route.params.id
        );
        this.$store.dispatch(
          "orders/fetchOrderAssetRentalItems",
          this.$route.params.id
        );
        await this.$store.dispatch("orders/fetchNotes", this.$route.params.id);

        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          `${toastComponentName} ${this.$translate("update_alert")}`
        );

      
        this.$forceUpdate();
      } catch (error) {
        console.error("update", error);
        let message =
          error.message || this.$translate("error_updating_activity");
        this.doToast(this.$translate("error"), message, "danger");
      } finally {
        console.log("done bingo bye");
        this.updating = false;
      }
    },

    currency(num) {
      num = parseFloat(num);
      console.log("num.......", num);
      try {
        return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      } catch (err) {
        return "0.00";
      }
    },
    toggleCompletion() {
      if (this.order.completed) {
        this.markAsIncomplete();
      } else {
        this.markAsComplete();
      }
    },
    async releaseActivity() {
      const title = this.$translate("release_activity_title");
      const message = this.$translate(`release_activity_note`);
      const result = await this.confirmMessage(title, message);
      if (result) {
        try {
          await this.$store.dispatch(
            "orders/markAsRelease",
            this.$route.params.id
          );

          this.doToast(
            this.$translate("success"),
            this.$translate("activity_released"),
            "success"
          );
        } catch (error) {
          this.doToast(
            this.$translate("error"),
            error.message,
            // this.$translate("activity_released_error"),
            "danger"
          );
        }
      }
    },
    async markAsComplete() {
      const title = this.$translate("mark_as_complete_title");
      const message = this.$translate(`mark_as_complete_note`);
      const result = await this.confirmMessage(title, message);
      if (!result) return;
      navigator.geolocation.getCurrentPosition(async (p) => {
        try {
          this.updating = true;
          const id = this.$route.params.id;
          var lat = p.coords.latitude;
          var long = p.coords.longitude;
          const getAddress = await this.$store.dispatch(
            "orders/geocodeStreet",
            { lat, long }
          );
          const address = {
            lat: p.coords.latitude,
            long: p.coords.longitude,
            signature_address: getAddress?.[0]?.display_name || '',
          };
          // console.log("Add",Address)
          await this.$store.dispatch("orders/markAsComplete", {
            id,
            address,
          });
          this.genericToast(
            this.componentName,
            this.$translate("updated"),
            "success",
            this.$translate("activity_complete")
          );
        } catch (error) {
          console.error("mark as complete", error);
          this.doToast(this.$translate("error"), error.message, "danger");
        } finally {
          this.updating = false;
        }
      });
    },
    async markAsIncomplete() {
      const title = this.$translate("mark_as_incomplete");
      const message = this.$translate(`mark_as_incomplete_note`);
      const result = await this.confirmMessage(title, message);
      if (!result) return;

      try {
        this.updating = true;
        await this.$store.dispatch(
          "orders/markAsIncomplete",
          this.$route.params.id
        );

        this.genericToast(
          this.componentName,
          this.$translate("updated"),
          "success",
          this.$translate("activity_incomplete")
        );
      } catch (error) {
        console.error("markAsIncomplete", error);
        this.doToast(
          this.$translate("error"),
          this.$translate("activity_incomplete_error"),
          "danger"
        );
      } finally {
        this.updating = false;
      }
    },

    deleteOrder() {
      // Initializing key variables
      const { id } = this.order;
      const name = this.$translate("activity");
      const model = { id, name };

      const routes = {
        baseRoute: "/orders",
        deleteRoute: "orders/delete",
      };
      const notificationFields = {
        type: this.$translate("activity"),
        errorMsg: this.$translate("unable_to_delete_activity"),
      };

      this.deleteItem(notificationFields, model, routes);
    },

    async duplicateActivity() {
      const title = this.$translate("duplicate_activity_title");
      const message = this.$translate(`duplicate_activity_note`);
      const result = await this.confirmMessage(title, message);
      if (result) {
        try {
          this.toggleOverlay = true;
          let id = this.$route.params.id;
          const updateModel = {
            duplicate_order_id: id,
          };
          const data = await this.$store.dispatch(
            "orders/duplicate_order",
            updateModel
          );

          setTimeout(() => {
            this.doToast(
              this.$translate("success"),
              `${this.$translate("activity")} 
                            ${data.reference_no} 
                            ${this.$translate("duplicated_alert")}`,
              "success"
            );
          }, 500);
        } catch (error) {
          this.doToast(
            this.$translate("error"),
            this.$translate("activity_duplicated_error"),
            "danger"
          );
        } finally {
          this.toggleOverlay = false;
        }
      }
    },
    async loadCustomerAssets(customer_id) {
      const $this = this;
      if (!customer_id) return;
      if (this.customerAssets > 0) return;

      console.log("loadCustomerAssets customer_id", customer_id);

      const asyncNextTick = () => {
        return new Promise((resolve) => {
          $this.$nextTick(() => resolve());
        });
      };

      const query = "";
      // // allow to see company asset as well with customer asset list to select with item detail.
      const filters = { customer_id, allow_company_asset: true };

      let assets = [];
      let page = 0;
      do {
        this.$store.dispatch("assets/fetch", {
          query,
          page,
          filters,
        });

        await asyncNextTick();

        const { assets } = this.$store.state.assets;
        page++;

        for (const asset of assets) {
          const { id, name, serial_no } = asset;
          if (!this.customerAssets.some((x) => x.id == id))
            this.customerAssets.push({ id, name, serial_no });
        }
        // code block to be executed
      } while (assets.length > 0);
      console.log("getCustomerAllAssets ", this.customerAssets);
    },

    signatureData(signatureData) {
      console.log("signatureData", signatureData);
    },

    returnItemSubmitted(){
      console.log('returnneddd---')
      this.viewMode=true
      this.runSaveActionNew()
    },
    async openModal(){
      this.$bvModal.show('order-template-export')
    },
    async bulkStatement(){
      try {
       
        this.toggleOverlay = true;
        const { export_option } = this;
        const { id } = this.order;
        const orders = [id];
        console.log("orders--tests", orders);
        await this.$store.dispatch("orders/bulkStatement", { orders , export_option});
       
      } catch (error) {
        this.doToast(this.$translate("error"), error.message, "danger");
      } finally {
        this.toggleOverlay = false;
      }
    },

    async create_receipt(){
      try {
       
       this.toggleOverlay = true;
       const { export_option } = this;
       const { id } = this.order;
       const orders = [id];
       console.log("orders--tests", orders);
       await this.$store.dispatch("orders/generateReceipt", { orders});
      
     } catch (error) {
       this.doToast(this.$translate("error"), error.message, "danger");
     } finally {
       this.toggleOverlay = false;
     }
    }
  },
  destroyed() {
    EventBus.$off("set-order-model");
  },
};
</script>
